import React from 'react'
import formatMessage from 'format-message'
import StrikeoutLine from './StrikeoutLine'
import HighlightRect from './HighlightRect'
import Annotation from './Annotation'
import SecondaryControls from '../SecondaryControls'
import { saveCommentFn } from './utils.js'
import { getRectFromCoords } from './utils'
import './StrikeoutAnnotation.css'
import { DEFAULT_STRIKEOUT_ANNOTATION_COLOR } from '../constants'

export default function StrikeoutAnnotation(props) {
  const {
    annotation,
    canEdit,
    canDelete,
    commentReplies,
    onCreateAnnotation,
    onCurrentColorChange,
    onUpdateAnnotation,
    selectionBoxPadding,
    sessionUserObject,
    viewportHeight,
    viewportScale,
  } = props

  const handleCommentSave = saveCommentFn({
    annotation,
    commentReplies,
    onUpdateAnnotation,
    viewportHeight,
    viewportScale,
    onCreateAnnotation,
    sessionUserObject,
  })

  const updateColor = (color) => {
    onUpdateAnnotation(viewportHeight, viewportScale, { ...annotation, color })
    onCurrentColorChange(color, 'strikeout')
  }
  const [[x1, y1], [x2, y2]] = annotation.rect
  const width = x2 - x1
  const height = y1 - y2

  const secondaryControls = (
    <SecondaryControls
      controlMode="strikeout"
      currentColor={annotation.color}
      onCurrentColorChange={updateColor}
    />
  )

  if (!(annotation.coords instanceof Array)) {
    throw new Error('coords missing on strikeout annotation')
  }

  const lines = annotation.coords.map((rect, index) => {
    const transformedRect = rect.map((coordinate) => {
      return [coordinate[0] - x1 + selectionBoxPadding, coordinate[1] - y2 + selectionBoxPadding]
    })

    return <StrikeoutLine key={index} rect={transformedRect} />
  })

  const rects = annotation.coords
    .map(getRectFromCoords)
    .filter((rect) => rect.top !== rect.bottom && rect.left !== rect.right) // Remove empty rects
    .map((rect, index) => {
      const transformedRect = {
        left: rect.left - x1 + selectionBoxPadding,
        top: rect.top - y2 + selectionBoxPadding,
        right: rect.right - x1 + selectionBoxPadding,
        bottom: rect.bottom - y2 + selectionBoxPadding,
      }
      return <HighlightRect key={index} rect={transformedRect} />
    })

  return (
    <Annotation
      {...props}
      annotation={annotation}
      canEdit={canEdit}
      canDelete={canDelete}
      className="StrikeoutAnnotation"
      iconColor={annotation.color ? annotation.color : DEFAULT_STRIKEOUT_ANNOTATION_COLOR}
      height={height}
      id={annotation.id}
      isMovable={false}
      onCommentSave={handleCommentSave}
      render={(_isSvgContainerFocused) => [
        <g key="hitpath" role="presentation" fillOpacity={0.001}>
          {rects}
        </g>,
        <g
          key="lines"
          role="presentation"
          stroke={
            typeof annotation.color === 'string'
              ? annotation.color
              : DEFAULT_STRIKEOUT_ANNOTATION_COLOR
          }
          fillOpacity={typeof annotation.opacity === 'number' ? annotation.opacity : 1}
          strokeWidth="1.5"
        >
          {lines}
        </g>,
      ]}
      secondaryControls={secondaryControls}
      title={formatMessage('Strikeout annotation')}
      width={width}
      x={x1}
      y={y2}
    />
  )
}
